var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mysnackbar.modal ? 'snackbar-overlay show ' + _vm.mysnackbar.type : 'snackbar-overlay hide'},[_c('div',{staticClass:"snackbar-container"},[_c('p',[_vm._v(_vm._s(_vm.mysnackbar.message))]),_c('span',{staticClass:"close",on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("X")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }